import { Module } from 'vuex';
import { AxiosError } from 'axios';
import { getError } from '@/plugins';

interface IErrorState {
  name: string;
  message: string;
  debugInfo: string;
}

export default <Module<IErrorState, any>>{
  state: {
    name: '',
    message: '',
    debugInfo: '',
  },
  mutations: {
    setError(state, { name = '', message = '', config, response, code, status }: AxiosError) {
      let _errorMessage = `${name} ${message}`;
      name = name === 'AxiosError' ? 'Ошибка сервера' : 'Ошибка клиента';

      if (response) {
        if (status === 501 || status === 502) {
          name = 'Сервер временно недоступен, зайдите позже';
          _errorMessage = '';
        } else {
          _errorMessage = getError(response);
        }
      }

      state.name = name;
      state.message = _errorMessage;

      const isDebug = true; //process.env.VUE_APP_DEBUG === 'true';

      if (isDebug) {
        const params = config?.data && config.data.length < 500 ? '\n' + config.data : undefined;
        state.debugInfo = [status, config?.method, config?.url, code, params].filter((r) => r).join(' ');
      }
    },

    clearError(state) {
      state.name = '';
      state.message = '';
      state.debugInfo = '';
    },
  },
  actions: {
    setError({ commit, dispatch }, e: AxiosError) {
      // Пропускаем при разлогинивание пользователя
      if (e.response?.status === 401 || e.response?.status === 423) {
        return;
      }

      dispatch('setLoader'); // Если был лоадер, а возникла ошибка, к ней не попасть
      commit('setError', e);
    },
  },
  getters: {
    error: (state): IErrorState => state,
  },
};
